import React, { Component } from "react";
import styles from "./styles.scss";
import SearchBar from "../../../components/SearchBar/SearchBar";
import { connect } from "react-redux";
import { actions } from "./redux";
import { Button, Grid, Input } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import List from "@material-ui/core/List";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import CSSModules from "react-css-modules";
import SmartTable from "../../../components/SmartTable/SmartTable";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

function Transition(props) {
	return <Slide direction="up" {...props} />;
}

@CSSModules(styles, { allowMultiple: true })
class Rules extends Component {
	componentWillMount() {}

	render() {
		return (
			<div>
				<Grid container item styleName="flex-center">
					<Grid item styleName="selected-rule-instance">
						{(this.props.selectedRuleInstance.siteName
							? this.props.selectedRuleInstance.siteName.replace(/site_/gi, "") + " - "
							: "") + this.props.selectedRuleInstance.name}{" "}
						<Button
							styleName="search-button search-button-large"
							onClick={this.handleClickOpen}
							style={{ margin: "0px 10px" }}
						>
							Change Rule
						</Button>
					</Grid>
					<Button
						styleName="search-button search-button-small"
						onClick={this.handleClickOpen}
						style={{ margin: "10px 0px" }}
					>
						Change Rule
					</Button>
				</Grid>
				<Dialog open={this.state.open} onClose={this.handleClose} TransitionComponent={Transition}>
					<AppBar styleName="appBar">
						<Toolbar>
							<Typography variant="title" color="inherit" styleName="flex">
								Select Rule Instance
							</Typography>
							<IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
								<CloseIcon />
							</IconButton>
						</Toolbar>
					</AppBar>
					<div styleName="component-wrapper-extra-padding">
						<div styleName="searchBarContainer">
							<SearchBar
								noTypeahead={true}
								timeout={500}
								searchBarId={"reports/ruleinstances"}
								style={{
									backgroundColor: "transparent",
									height: 60,
									marginLeft: 15,
									marginRight: 15,
									borderBottomWidth: 0
								}}
								inputStyle={{ borderWidth: 0 }}
								iconStyle={{ color: "#FFFFFF" }}
							/>
						</div>
						<SmartTable
							rowsPerPage={10}
							columns={2}
							smartTableId="SitesListTable"
							data={this.props.ruleInstancesList}
							useResponsiveColumns={false}
							breakOn="sm"
							changeData={newData => this.props.changeData(newData)}
							allowColumnSort={true}
							tableClass="table-class"
							collapsedTableHeadersStyle="td-content"
							tdClass="st-td"
							classes={styles}
						>
							<thead>
								<tr>
									<th styleName="table-header text-left" sortable="name">
										Rule
									</th>
									<th styleName="table-header text-left" sortable="ruleCategoryCode">
										Category
									</th>
								</tr>
							</thead>
							<tbody>
								{this.props.ruleInstancesList.map((x, i) => {
									return (
										<tr
											key={i}
											styleName="table-row"
											onClick={() => {
												this.selectRuleInstance(x.ruleInstanceId);
												this.handleClose();
											}}
										>
											<td>
												<div styleName="td-content">{x.name}</div>
											</td>
											<td>
												<div styleName="td-content">{x.ruleCategoryCode}</div>
											</td>
										</tr>
									);
								})}
							</tbody>
						</SmartTable>
					</div>
				</Dialog>
			</div>
		);
	}

	state = {
		open: false
	};

	handleClickOpen = () => {
		this.setState({ open: true });
		this.props.searchRuleInstances();
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	selectRuleInstance = ruleInstanceId => {
		this.props.loadRuleInstance(ruleInstanceId);
	};

	componentWillUnmount() {
        this.props.resetState();
    }
}

const bindAction = dispatch => {
	return {
		changeData: data => dispatch(actions.getRuleInstances(data)),
		loadRuleInstance: ruleInstanceId => dispatch(actions.loadRuleInstance(ruleInstanceId)),
        searchRuleInstances: () => dispatch(actions.onSearch()),
        resetState: () => dispatch(actions.resetState())
	};
};

const mapStateToProps = state => ({
	selectedRuleInstance: state.ruleinstancesearch.selectedRuleInstance,
	ruleInstancesList: state.ruleinstancesearch.ruleInstancesList,
	currentSite: state.sitetree.currentSite
});

export default connect(
	mapStateToProps,
	bindAction
)(Rules);



// WEBPACK FOOTER //
// ./src/components/ReportComponents/RuleInstanceSearch/RuleInstanceSearch.js